import React from 'react'

import './index.scss'

const ToolboxSeparator = ({ className }: { className?: string }) => {
  return <div className={`commonSeparator ${className}`} />
}

export default ToolboxSeparator
